module.exports = __webpack_public_path__ + "img/Kalt.043e9c44.svg";